import { alertSuccess } from "$utils/alerts"

export const processSuccess = (_, { successMessage, successMessageButtons }) => {
  successMessage && alertSuccess(successMessage, successMessageButtons)
}
